import onYoutubePlayerReady from 'helpers/youtube/onYoutubePlayerReady';
import onYoutubeStateChange from 'helpers/youtube/onYoutubeStateChange';

export default function getYoutubeConfig (videoId) {
  return {
    height: '720',
    width: '1280',
    videoId,
    playerVars: {
      autoplay: 0,
      controls: 0,
      disablekb: 1,
      showinfo: 0,
      loop: 1,
      rel: 0,
      playlist: videoId,
      modestbranding: 1,
      iv_load_policy: 3,
      html5: 1,
    },
    events: {
      onReady: onYoutubePlayerReady,
      onStateChange: onYoutubeStateChange,
    },
  };
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/youtube/getYoutubeConfig.js